/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { useSelector } from "react-redux"
import { AppState } from "store/store.type"
import { INVENTORY } from "constants/routes"
import { Location } from "history"
import { useLocation } from "react-router"
import { getUCMConfig } from "utils/config"
import { getUserRole } from "troy-common/utils"
import { ROLE_STORE_MANAGER } from "troy-common/constants"
import useSingleStoreUser from "./useSingleStoreUser"

export function isInventory(location: Location) {
  return location.pathname.startsWith(INVENTORY)
}

export function getMustEditThroughMenu(location: Location) {
  return isInventory(location)
}

export default function useInventoryContext() {
  const location = useLocation()
  const { isSingleStoreUser } = useSingleStoreUser()
  const { isMenuGroup } = useSelector((s: AppState) => ({
    isMenuGroup: s.menu.isMenuGroup,
  }))
  return {
    mustEditThroughMenu: getMustEditThroughMenu(location),
    disableAvailability: Boolean(
      !isInventory(location) &&
        getUCMConfig("enableInventory") &&
        (!isSingleStoreUser || isMenuGroup),
    ),
    enableInventory: Boolean(getUCMConfig("enableInventory")),
    hideCreateAction: isInventory(location),
    hideDeleteAction: Boolean(
      isInventory(location) &&
        !isSingleStoreUser &&
        getUserRole() !== ROLE_STORE_MANAGER,
    ),
    isInventory: isInventory(location),
  }
}
